export const TaxUnits = [
  { value: "percentage", label: "Percentage" },
  { value: "constant", label: "Constant" },
];

export const LinkExpireUnits = [
  { value: "Day", label: "Day" },
  { value: "Hour", label: "Hour" },
];
